




























import {Prop, Watch} from "vue-property-decorator";
	import {Component, Vue} from '@/shared/component';

	import {storeEssenceAchatsTotaux, EssenceAchatFilter} from '@/stores/modules/essenceAchat';
	
	import CrudList from '@/components/Crud/List.vue';
	import TableHead from '@/components/Paginate/TableHead.vue';
	import TableCell from '@/components/Paginate/TableCell.vue';
	import Checked from '@/components/Checked.vue';
	import {Stored} from "vue-stored-prop-decorator/index";
import {WatchObjectProperties} from "@/shared/decorator";
import {FournisseurFilter} from "@/stores/modules/fournisseur";
	
	@Component({
		components: {
			CrudList,
			TableHead,
			TableCell,
			Checked,
		}
	})
	export default class CrudEssenceAchatListTotauxEssenceAchats extends Vue {
		
		@Prop({type: Boolean, default: true  }) private paginate;
		@Prop({type: Boolean, default: false }) private dense;
		@Stored(() => storeEssenceAchatsTotaux) private filters!: EssenceAchatFilter;
		
		private storeEssenceAchatsTotaux = storeEssenceAchatsTotaux;

		private headers = [];
		private search = '';

		@WatchObjectProperties('filters', EssenceAchatFilter)
		private filterWatcher(): void {
			var essence = { text: 'Essence', value: 'boisType' }
			var longueur = { text: 'Longueur', value: 'longueursAchat' }
			var volume = { text: 'Volume restant', value: 'volumeRestant' }
			this.headers = [];
			if (this.filters.totalParBoisType) {
				this.headers.push(essence)
			}
			if (this.filters.totalParLongueur) {
				this.headers.push(longueur)
			}
			this.headers.push(volume)
		}
	}
